import { render, staticRenderFns } from "./BannerTableHeader.vue?vue&type=template&id=823f396c&scoped=true&"
import script from "./BannerTableHeader.vue?vue&type=script&lang=js&"
export * from "./BannerTableHeader.vue?vue&type=script&lang=js&"
import style1 from "./BannerTableHeader.vue?vue&type=style&index=1&id=823f396c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823f396c",
  null
  
)

export default component.exports